import { useCallback } from 'react';

import type { SiteWithApis } from '@/stores';
import { useLayoutStorage } from '@/stores/layout.ts';
import { WidgetConfigModalProps } from '@/types.ts';

/** When editing a layout widget, keep `siteId` in sync with the active site tab on save. */
export const useWidgetSiteTabbedShellSave = (
  widgetId: string | undefined,
  onSave: WidgetConfigModalProps['onSave']
): WidgetConfigModalProps['onSave'] => {
  const updateWidgetSiteId = useLayoutStorage(s => s.updateWidgetSiteId);
  const widgetSiteId = useLayoutStorage(s => (widgetId ? s.getWidgetSiteId(widgetId) : undefined));

  return useCallback(
    (props, site?: SiteWithApis) => {
      if (widgetId && site?.id && site.id !== widgetSiteId) {
        updateWidgetSiteId({ widgetId, siteId: site.id });
      }
      onSave(props, site);
    },
    [onSave, updateWidgetSiteId, widgetId, widgetSiteId]
  );
};

export const resolveWidgetDefaultSiteKey = (
  widgetSiteId: string | undefined,
  sites: readonly SiteWithApis[]
): string | undefined => {
  if (!widgetSiteId) return undefined;
  const canonicalSiteId = sites.find(site => site.id === widgetSiteId)?.id ?? widgetSiteId;
  return `siteId:${canonicalSiteId}`;
};
